import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const tooltipStyle = {
  borderRadius: '8px',
  border: 'none',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  fontSize: '12px',
};

const TPLeaderboardChart = ({ data }) => {
  const tpMap = {};
  (data || []).forEach(r => {
    const tp = r.tpName || 'Unknown';
    if (!tpMap[tp]) {
      tpMap[tp] = { tp, screeningCalls: 0, passedAfterScreening: 0, finalStages: 0, offersAccepted: 0 };
    }
    tpMap[tp].screeningCalls += r.screeningCalls || 0;
    tpMap[tp].passedAfterScreening += r.passedAfterScreening || 0;
    tpMap[tp].finalStages += r.finalStages || 0;
    tpMap[tp].offersAccepted += r.offersAccepted || 0;
  });

  const chartData = Object.values(tpMap).sort((a, b) => b.screeningCalls - a.screeningCalls);

  return (
    <div className="dashboard-card p-6 slide-in-up">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold text-gray-800">TP Activity Leaderboard</h3>
        <div className="bg-purple-100 text-purple-800 text-xs font-medium px-2.5 py-1 rounded-full">
          Filtered Data
        </div>
      </div>
      <p className="text-sm text-gray-600 mb-4">Activity breakdown per Talent Partner for selected filters</p>
      {chartData.length === 0 ? (
        <div className="flex items-center justify-center h-48 text-gray-400 text-sm">No data available</div>
      ) : (
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={chartData} layout="vertical" margin={{ top: 4, right: 16, left: 60, bottom: 4 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" horizontal={false} />
            <XAxis type="number" tickLine={false} axisLine={false} style={{ fontSize: '12px' }} allowDecimals={false} />
            <YAxis type="category" dataKey="tp" tickLine={false} axisLine={false} style={{ fontSize: '12px' }} width={56} />
            <Tooltip contentStyle={tooltipStyle} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="screeningCalls" name="Screening" fill="#4841F0" radius={[0, 3, 3, 0]} />
            <Bar dataKey="passedAfterScreening" name="Passed" fill="#6366f1" radius={[0, 3, 3, 0]} />
            <Bar dataKey="finalStages" name="Finals" fill="#8b5cf6" radius={[0, 3, 3, 0]} />
            <Bar dataKey="offersAccepted" name="Offers ✓" fill="#10b981" radius={[0, 3, 3, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default TPLeaderboardChart;
